export default {
  title: 'Datos fiscales',
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    success: 'Información guardada correctamente.',
  },
};
